// 暂时用不到 移动到 chat ui 了
import React, { useState, useMemo } from 'react';
import { observer, inject } from 'mobx-react';
import sanitizeHtml from 'sanitize-html';
import { Button, Modal, ButtonGroup } from '@shopee/chatbot-ui';
import { ButtonProps } from '@shopee/chatbot-ui/lib/components/Button';
import sanitizeHtmlOptions from '@/utils/sanitizeHtmlOptions';
import { ButtonEvents } from '@shopee/chatbot-ui/lib/types';
import './style.scss';

export interface PopUpAnnouncementModalProps {
  popUpAnnouncement?: {
    title: string;
    message: string;
    button_setting: {
      button_style: number;
      button_text: string;
      button_function: number;
      url?: string;
    }[];
  };
  visible: boolean;
  onClose: () => void;
}

enum ButtonFunction {
  ClosePopUp = 1,
  JumpUrl,
}

enum ButtonStyle {
  PrimaryButton = 1,
  SecondaryButton,
}

const PopUpAnnouncementModal: React.FC<PopUpAnnouncementModalProps> = (props) => {
  const { popUpAnnouncement, onClose, visible } = props ?? {};
  const { message, title, button_setting = [] } = popUpAnnouncement ?? {};
  const buttons: ButtonProps[] = useMemo(() => {
    return button_setting?.map((v) => {
      const defaultObj = {
        text: v.button_text,
        style: { color: v.button_style === ButtonStyle.PrimaryButton ? '#EE4D2D' : 'rgba(0, 0, 0, 0.87)' },
        onClick: () => {
          onClose();
        },
      };
      if (v?.button_function === ButtonFunction.JumpUrl) {
        return {
          ...defaultObj,
          action: {
            func: ButtonEvents.Redirection,
            url_info: { url: v.url },
            showUserMessage: false,
          },
        };
      }
      return defaultObj;
    });
  }, [button_setting]);

  return (
    <>
      <Modal
        active={visible}
        onClose={onClose}
        title={title}
        className="pop-up-announcement"
        contentClassName="pop-up-announcement-modal-content"
      >
        <div className="pop-up-announcement-content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(message ?? '', sanitizeHtmlOptions) }} />
        <ButtonGroup
          buttons={buttons as any}
        />
      </Modal>
    </>
  );
};

export default PopUpAnnouncementModal;
